
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30289',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30289",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54570",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8019",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11477",
  "I18n": "static-7.1628",
  "quartz": "static-1.7040",
  "quartz-config": "static-1.818",
  "quartz-core": "static-1.6259",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.794",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54557",
  "feedback-utils": "static-1.54561",
  "forms-embed-utils-lib": "static-1.4470",
  "forms-utils-lib": "static-1.12595",
  "foundations-assets": "static-1.4871",
  "foundations-components": "static-1.7946",
  "foundations-theming": "static-1.4423",
  "hub-http": "static-1.6227",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11784",
  "icons": "static-2.647",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3920",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5348",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57489",
  "transmute": "static-2.85",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8423",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3317",
  "quartz-webpack": "static-1.3264",
  "foundations-theming-specialty": "static-1.2139",
  "property-description-translator": "static-1.3851",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3130",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4333",
  "jasmine-runner": "static-1.6470",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4655",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.715",
  "quartz-head": "static-1.705",
  "quartz-i18n": "static-1.715",
  "quartz-routing": "static-1.470",
  "quartz-test": "static-1.715",
  "quartz-tracking": "static-1.419",
  "ui-fonts": "static-1.739",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7253",
  "reference-resolvers": "static-1.8177",
  "sanitize-text": "static-1.8148",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10371",
  "sanitize": "static-1.4483",
  "outpost": "static-1.4188",
  "rpc-client-utils": "static-1.4658",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4215",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9430",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1960",
  "bend-plugin-foundations-theming": "static-1.2906",
  "foundations-theming-base": "static-1.3408",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.84",
  "csstype": "static-1.50",
  "web-vitals": "static-1.5",
  "ai-components-ui-library": "static-1.8992",
  "atom": "static-1.5077",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7760",
  "ContentUtils": "static-1.68372",
  "data-token-picker": "static-1.16419",
  "file-manager-components": "static-1.23639",
  "FileManagerCore": "static-1.39138",
  "FileManagerLib": "static-1.39279",
  "frontend-preferences-client": "static-1.7934",
  "hub-http-contrib": "static-1.3048",
  "interframe": "static-3.4766",
  "layout-dnd-components": "static-1.12459",
  "layout-dnd-utils": "static-1.11434",
  "property-translator": "static-1.5407",
  "react-codemirror": "static-1.10632",
  "react-colorpicker": "static-2.10213",
  "reference-resolvers-lite": "static-1.8100",
  "rich-text-lib": "static-1.19845",
  "tinymce-data": "static-1.40460",
  "tinymce-themes": "static-1.56345",
  "ui-addon-emoji-picker": "static-1.9894",
  "ui-addon-sales-email": "static-1.5217",
  "ui-brand-identity-lib": "static-1.15289",
  "bender-build-tools": "static-1.3205",
  "hub-http-shared-msw-handlers": "static-1.9970",
  "hubspotter-http-shared-msw-handlers": "static-1.9968",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.68",
  "chirp-fetch": "static-1.1894",
  "chatspot-core": "static-1.21336",
  "copilot-toolkit": "static-1.11146",
  "customer-data-objects-ui-components": "static-1.13032",
  "data-fetching-client": "static-1.9675",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4766",
  "ui-addon-video-player": "static-1.8708",
  "ui-coaching-tips": "static-1.28564",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "static-1.4817",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16145",
  "customer-data-objects": "static-1.7675",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4656",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4160",
  "ui-addon-iframeable": "static-1.9063",
  "video-components-external": "static-1.11275",
  "video-data-lib": "static-1.34933",
  "audio-components": "static-1.5922",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29305",
  "FileManagerImages": "static-1.36790",
  "foundations-components-legacy": "static-1.971",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.8985",
  "urlinator": "static-1.4543",
  "video-components": "static-1.13278",
  "video-embed": "static-1.35767",
  "ts-schema": "static-1.4083",
  "ContentData": "static-1.68447",
  "layout-data-lib": "static-1.9759",
  "react-dnd-compat": "static-1.4620",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1546",
  "external-options-client-types": "static-1.4162",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6890",
  "hs-promise-utils": "static-1.5598",
  "inbound-db-properties-service-client": "static-1.3849",
  "NamespacedHubStyle": "static-2.9062",
  "growth-onboarding-confetti": "static-1.3072",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11155",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5555",
  "magpie-types": "static-1.5015",
  "simple-logging-lib": "static-1.3055",
  "avatar-components": "static-1.2502",
  "customer-data-ui-utilities": "static-1.9832",
  "growth-onboarding-feedback-components": "static-1.6586",
  "flux-actions": "static-1.338",
  "hubspot-apollo-client": "static-1.4884",
  "integrations-error-boundary-lib": "static-1.13560",
  "integrations-tracking-lib": "static-1.5607",
  "laboratory-lib": "static-3.7162",
  "native-integrations-shared-strings": "static-1.7788",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10169",
  "unified-auth": "static-1.499",
  "navigation-messaging": "static-1.7377",
  "content-media-composition-data-lib": "static-1.12301",
  "content-media-compositions": "static-2.16308",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18937",
  "unified-auth-core-lib": "static-1.781",
  "social-insights-client-types": "static-1.22118",
  "advanced-menus-core": "static-1.15136",
  "advanced-menus-lib": "static-1.12076",
  "ExportDialog": "static-6.10394",
  "ui-memberships-settings-lib": "static-1.34053",
  "conditional-properties-service-client": "static-1.3800",
  "crm-pipelines-api-client-types": "static-1.4142",
  "fdsr-migration-layer": "static-1.9",
  "framework-builder-read-service-client": "static-1.4008",
  "framework-data-schema-quick-fetch": "static-1.6795",
  "inbound-db-meta-service-client": "static-1.3589",
  "multi-currency-client-types": "static-1.3694",
  "persist-promise": "static-1.3703",
  "foundations-components-test-utils": "static-1.5429",
  "reactive-lib": "static-1.729",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.343",
  "universal-page-editor-lib": "static-1.3018",
  "google-sheets-integration-lib": "static-1.244",
  "microsoft-drive-integration-lib": "static-1.363",
  "slack-ui-library": "static-1.10399",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3736",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15135",
  "simple-menus-lib": "static-1.16652",
  "crm-record-cards-service-types": "static-1.3600",
  "location-customization-utils-lib": "static-1.9268",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30289",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54570",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8019",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11477",
  "I18n": "/I18n/static-7.1628",
  "quartz": "/quartz/static-1.7040",
  "quartz-config": "/quartz-config/static-1.818",
  "quartz-core": "/quartz-core/static-1.6259",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.794",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54557",
  "feedback-utils": "/feedback-utils/static-1.54561",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4470",
  "forms-utils-lib": "/forms-utils-lib/static-1.12595",
  "foundations-assets": "/foundations-assets/static-1.4871",
  "foundations-components": "/foundations-components/static-1.7946",
  "foundations-theming": "/foundations-theming/static-1.4423",
  "hub-http": "/hub-http/static-1.6227",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11784",
  "icons": "/icons/static-2.647",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5348",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57489",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8423",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3317",
  "quartz-webpack": "/quartz-webpack/static-1.3264",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2139",
  "property-description-translator": "/property-description-translator/static-1.3851",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3130",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4333",
  "jasmine-runner": "/jasmine-runner/static-1.6470",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.715",
  "quartz-head": "/quartz-head/static-1.705",
  "quartz-i18n": "/quartz-i18n/static-1.715",
  "quartz-routing": "/quartz-routing/static-1.470",
  "quartz-test": "/quartz-test/static-1.715",
  "quartz-tracking": "/quartz-tracking/static-1.419",
  "ui-fonts": "/ui-fonts/static-1.739",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7253",
  "reference-resolvers": "/reference-resolvers/static-1.8177",
  "sanitize-text": "/sanitize-text/static-1.8148",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10371",
  "sanitize": "/sanitize/static-1.4483",
  "outpost": "/outpost/static-1.4188",
  "rpc-client-utils": "/rpc-client-utils/static-1.4658",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4215",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9430",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1960",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2906",
  "foundations-theming-base": "/foundations-theming-base/static-1.3408",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.84",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.5",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8992",
  "atom": "/atom/static-1.5077",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7760",
  "ContentUtils": "/ContentUtils/static-1.68372",
  "data-token-picker": "/data-token-picker/static-1.16419",
  "file-manager-components": "/file-manager-components/static-1.23639",
  "FileManagerCore": "/FileManagerCore/static-1.39138",
  "FileManagerLib": "/FileManagerLib/static-1.39279",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7934",
  "hub-http-contrib": "/hub-http-contrib/static-1.3048",
  "interframe": "/interframe/static-3.4766",
  "layout-dnd-components": "/layout-dnd-components/static-1.12459",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11434",
  "property-translator": "/property-translator/static-1.5407",
  "react-codemirror": "/react-codemirror/static-1.10632",
  "react-colorpicker": "/react-colorpicker/static-2.10213",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8100",
  "rich-text-lib": "/rich-text-lib/static-1.19845",
  "tinymce-data": "/tinymce-data/static-1.40460",
  "tinymce-themes": "/tinymce-themes/static-1.56345",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9894",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5217",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15289",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9970",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9968",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.68",
  "chirp-fetch": "/chirp-fetch/static-1.1894",
  "chatspot-core": "/chatspot-core/static-1.21336",
  "copilot-toolkit": "/copilot-toolkit/static-1.11146",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13032",
  "data-fetching-client": "/data-fetching-client/static-1.9675",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4766",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8708",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28564",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "/cms-field-types/static-1.4817",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16145",
  "customer-data-objects": "/customer-data-objects/static-1.7675",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4656",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4160",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9063",
  "video-components-external": "/video-components-external/static-1.11275",
  "video-data-lib": "/video-data-lib/static-1.34933",
  "audio-components": "/audio-components/static-1.5922",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29305",
  "FileManagerImages": "/FileManagerImages/static-1.36790",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.971",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.8985",
  "urlinator": "/urlinator/static-1.4543",
  "video-components": "/video-components/static-1.13278",
  "video-embed": "/video-embed/static-1.35767",
  "ts-schema": "/ts-schema/static-1.4083",
  "ContentData": "/ContentData/static-1.68447",
  "layout-data-lib": "/layout-data-lib/static-1.9759",
  "react-dnd-compat": "/react-dnd-compat/static-1.4620",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1546",
  "external-options-client-types": "/external-options-client-types/static-1.4162",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6890",
  "hs-promise-utils": "/hs-promise-utils/static-1.5598",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3849",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9062",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3072",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11155",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "magpie-types": "/magpie-types/static-1.5015",
  "simple-logging-lib": "/simple-logging-lib/static-1.3055",
  "avatar-components": "/avatar-components/static-1.2502",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9832",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6586",
  "flux-actions": "/flux-actions/static-1.338",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4884",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13560",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5607",
  "laboratory-lib": "/laboratory-lib/static-3.7162",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7788",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10169",
  "unified-auth": "/unified-auth/static-1.499",
  "navigation-messaging": "/navigation-messaging/static-1.7377",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12301",
  "content-media-compositions": "/content-media-compositions/static-2.16308",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18937",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.781",
  "social-insights-client-types": "/social-insights-client-types/static-1.22118",
  "advanced-menus-core": "/advanced-menus-core/static-1.15136",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12076",
  "ExportDialog": "/ExportDialog/static-6.10394",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34053",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3800",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4142",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.9",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4008",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6795",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3589",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3694",
  "persist-promise": "/persist-promise/static-1.3703",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5429",
  "reactive-lib": "/reactive-lib/static-1.729",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.343",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3018",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.244",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.363",
  "slack-ui-library": "/slack-ui-library/static-1.10399",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3736",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15135",
  "simple-menus-lib": "/simple-menus-lib/static-1.16652",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3600",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9268",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
